import { Component, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { ToastComponent } from '../../shared/toast/toast.component';
import { setClassInvalid } from '../../shared/functions';
import { AuthService } from '../../services/auth.service';
import { ee } from '../../shared/constants';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
  standalone: false
})
export class LoginFormComponent {
  private auth = inject(AuthService);
  private formBuilder = inject(UntypedFormBuilder);
  toast = inject(ToastComponent);


  loginForm = this.createLoginForm();
  inputPasswordType = 'password';
  setClassInvalid = setClassInvalid;

  createLoginForm(): UntypedFormGroup {
    return this.formBuilder.group({
      email: ['', Validators.compose([
        Validators.email,
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(100)
      ])],
      password: ['', Validators.compose([Validators.required, Validators.minLength(6)])]
    });
  }

  changeContent(content: string): void {
    ee.emit('changeContent', content);
  }

  toggleInputPasswordType(): void {
    this.inputPasswordType = this.inputPasswordType === 'password' ? 'text' : 'password';
  }

  login(): void {
    this.auth.login(this.loginForm.value);
  }
}
